import { useCallback } from 'react';
import { pick } from 'ramda';
import { useSearchPlayerBonuses } from 'server';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as helpers from '../helpers';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../store';

export const useFetchComponent = () => {
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const searchPlayerBonuses = useSearchPlayerBonuses();
    const translate = useComponentTranslations();
    const {
        fromDate,
        toDate,
        statusFilter,
        page: { pageId }
    } = useDynamicReducerSelector(pick(['fromDate', 'toDate', 'statusFilter', 'page']));

    return useCallback((): void => {
        dispatch(actions.toggleLoading(true));
        dispatch(actions.setError({ error: '' }));

        (async () => {
            try {
                const { bonuses = [], paging: { nextPageId } = {} } = await searchPlayerBonuses({
                    paging: {
                        pageSize: '30',
                        pageId: pageId || '0'
                    },
                    playerBonusCriteria: {
                        ...statusFilter !== 'all' && { statusFilter },
                        issuedAfterDate: helpers.formatDateForIms(fromDate),
                        issuedBeforeDate: helpers.formatDateForIms(toDate)
                    }
                });

                dispatch(actions.updateHistory({
                    bonuses,
                    nextPageId
                }));
            } catch (error) {
                isMounted() && dispatch(actions.setError({ error: translate('error') }));
            } finally {
                isMounted() && dispatch(actions.toggleLoading(false));
            }
        })();

    }, [dispatch, fromDate, isMounted, pageId, searchPlayerBonuses, statusFilter, toDate, translate]);
};
